import { render, staticRenderFns } from "./LoginPagamento.vue?vue&type=template&id=52e2077d&scoped=true&"
import script from "./LoginPagamento.vue?vue&type=script&lang=js&"
export * from "./LoginPagamento.vue?vue&type=script&lang=js&"
import style0 from "./LoginPagamento.vue?vue&type=style&index=0&id=52e2077d&scoped=true&lang=scss&"
import style1 from "./LoginPagamento.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e2077d",
  null
  
)

export default component.exports